/**
 * Helper to get the dom rect from a react ref.
 */
export const domRect = reactRef => {
  return reactRef && reactRef.current && reactRef.current.getBoundingClientRect();
};
